import gsap, { Power3 } from 'gsap';

const preloader = document.querySelector('.preloader');

function animateIn (next) {
  const container = document.querySelector('#swup');
  gsap.fromTo(container, 
    {
      x: -80
    },
    {
      duration: 0.5,
      x: 0,
      force3D: true,
      ease: 'ease',
      onComplete: () => {
        container.style.transform = 'none'
      }
    }
  )

  gsap.fromTo(preloader,
    {
      x: 0
    },
    {
      x: '100%',
      duration: 0.5,
      force3D: true,
      ease: 'ease',
      onComplete: () => {
        gsap.set(preloader, { opacity: 0 })
        next()
      }
    }
  )
}

function animateOut (next) {
  gsap.set(preloader, { x: '-100%', opacity: 1, force3D: true })
  const container = document.querySelector('#swup');
  gsap.fromTo(container, 
    {
      x: 0
    },
    {
      duration: 1,
      x: 100,
      force3D: true,
      ease: Power3.easeIn
    }
  )
    
  gsap.fromTo(preloader, 
    {
      x: '-100%'
    },
    {
      x: 0,
      duration: 1,
      force3D: true,
      ease: Power3.easeIn,
      onComplete: next
    }
  )
}

const pageTransition = [
  {
    from: '(.*)',
    to: '(.*)',
    in: (next, infos) => {
      animateIn(next)
    },
    out: (next, infos) => {
      animateOut(next)
    }
  }
]

export default pageTransition;
